module.exports = __webpack_public_path__ + "img/services.48637bc7.jpg";